module.exports = __webpack_public_path__ + "static/src/content/silks/classique_legend.870322b.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/silks/classique_legend.png
// module id = e0fV
// module chunks = 0